import { AlertTriangle } from "lucide-react";

export default function FinancialDisclaimer({ compact = false }) {
  if (compact) {
    return (
      <p className="text-[10px] text-slate-400 text-center py-2" data-testid="financial-disclaimer-compact">
        Data is estimated and for informational purposes only. Not financial advice. Consult a qualified advisor.
      </p>
    );
  }

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 my-6" data-testid="financial-disclaimer">
      <div className="flex gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
        <div>
          <p className="text-xs font-semibold text-amber-800 mb-1">Important Disclaimer</p>
          <p className="text-xs text-amber-700 leading-relaxed">
            This is not financial advice. All salary calculations, tax estimates, and cost of living data shown on AffordScope are approximations for informational purposes only. 
            Actual costs may vary. Always consult a qualified financial advisor before making financial decisions. 
            Tax calculations use 2025 federal brackets and may not reflect your specific situation.
          </p>
        </div>
      </div>
    </div>
  );
}
